import { OPERATION_TYPES, OperationType } from './constants/portfolioConstants';

const MAX_LINE_REPARTITION_PERCENT = 30;

export interface ProjectedRepartitionParams {
  isPublic: boolean;
  operationType: OperationType;
  /**
   * The projected total market value of the line after the operation.
   * This must be in the same currency as portfolioMarketValue.
   */
  projectedLineMarketValueInPortfolioCurrency: number;
  /**
   * The total market value of the portfolio.
   * This must be in the same currency as projectedLineMarketValueInPortfolioCurrency.
   */
  portfolioMarketValue: number;
}

/**
 * Calculates the projected repartition percent of the line after the
 * current buy operation.
 */
export function projectedLineRepartitionPercent(
  params: ProjectedRepartitionParams
): number | null {
  const {
    isPublic,
    operationType,
    projectedLineMarketValueInPortfolioCurrency,
    portfolioMarketValue,
  } = params;

  if (!isPublic) return null;
  if (operationType !== OPERATION_TYPES.BUY) return null;
  if (projectedLineMarketValueInPortfolioCurrency <= 0) return null;
  if (portfolioMarketValue <= 0) return null;

  return (
    (projectedLineMarketValueInPortfolioCurrency / portfolioMarketValue) * 100
  );
}

export function projectedLineRepartitionPercentRounded(pct: number): number {
  return Math.floor(pct);
}

export function exceedsThirtyPercentRule(pct: number): boolean {
  return pct > MAX_LINE_REPARTITION_PERCENT;
}
